import { TranslationsParams } from "modules/translations/types";
import { useState, type FC, useEffect, ChangeEvent } from "react";
import TranslationInput from "shared/components/Translations/TranslationInput";
import { LocaleCode } from "shared/types/languages";

type Props = {
  handleUpdatedTranslations: (value: TranslationsParams) => void;
  locale: LocaleCode;
  rowValue: string;
  rowId: string | number;
  isLoading: boolean;
};

const TranslationTableField: FC<Props> = ({
  handleUpdatedTranslations,
  locale,
  rowValue,
  rowId,
  isLoading,
}) => {
  const [currentValue, setCurrentValue] = useState("");

  useEffect(() => {
    setCurrentValue(rowValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setCurrentValue(value);
    handleUpdatedTranslations({
      translationId: rowId.toString(),
      value,
      locale,
    });
  };

  return <TranslationInput value={currentValue} onChange={handleChange} />;
};

export default TranslationTableField;
